
<template>
  <!-- 物资登记表 -->
  <div class="buttonlist">
    <div class="buttonlist-m">
      <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="warning" plain class="el-icon-plus" @click="dialogFormVisible = true">新增</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <el-table :data="list" style="width: 100%" :row-style="tableRowStyle" :header-cell-style="tableHeaderColor">
          <el-table-column label="功能室名称" align="center" prop="name" />
          <el-table-column label="类型" align="center" prop="type" :formatter="formatType" />
          <el-table-column label="容纳人数" align="center" prop="people" />
          <el-table-column label="面积" align="center" prop="size" />
          <el-table-column label="楼层" align="center" prop="floor" />
          <el-table-column label="简介" align="center" prop="info" />
          <el-table-column label="操作" width="160" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <!-- <el-button type="danger" size="mini" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
          layout="total, prev, pager, next" :total="totalDataNumber" align="center" class="fenye"></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog :title="addForm.id == null ? '新增多功能室' : '编辑多功能室'" :visible.sync="dialogFormVisible"
        :close-on-click-modal="false" :close-on-press-escape="false" class="dangerbuttonxz" @close="closexz">
        <el-form ref="form" :model="addForm">
          <el-row>
            <el-col :span="12">
              <el-form-item label="功能室名称" :label-width="formLabelWidth" prop="name">
                <el-input v-model.trim="addForm.name" class="commonwidth" placeholder="请输入名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="类型" :label-width="formLabelWidth" prop="type">
                <el-select v-model="addForm.type" placeholder="请选择" class="commonwidth">
                  <el-option label="全部" value="0"></el-option>
                  <el-option label="文娱活动" value="1"></el-option>
                  <el-option label="运动健身" value="2"></el-option>
                  <el-option label="其他" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="容纳人数(人)" :label-width="formLabelWidth" prop="people">
                <el-input v-model.trim="addForm.people" class="commonwidth" placeholder="请输入人数"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="面积(㎡)" :label-width="formLabelWidth" prop="size">
                <el-input v-model.trim="addForm.size" class="commonwidth" placeholder="请输入面积"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="楼层" :label-width="formLabelWidth" prop="floor">
                <el-input v-model.trim="addForm.floor" class="commonwidth" placeholder="请输入楼层"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="图片" :label-width="formLabelWidth" prop="headPic">
                <el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
                  :show-file-list="false" :on-remove="handleRemove" :http-request="uploadSectionFile"
                  :before-upload="uploadSuccess">
                  <img v-if="addForm.headPic" :src="addForm.headPic" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <el-form-item label="简介" :label-width="formLabelWidth" prop="info">
                <el-input v-model.trim="addForm.info" type="textarea" class="bigwidth"
                  :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入简介"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="closexz">取 消</el-button>
          <el-button type="primary" @click="submitForm('addForm')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>
<script>
//入库 ,物资登记
export default {
  name: "MultiRoomList",
  data() {
    return {
      addForm: {
        headPic:null,
      },
      filteForm: {
        dayStr: ""
      },
      list: [],
      currentPage: 1,
      addLoading: false,
      totalDataNumber: 0,
      pageNum: 1,
      formLabelWidth: '120px',
      loading: false,
      dialogFormVisible: false,

    };
  },
  methods: {

    //活动轮播图图片上传
    uploadSectionFile(param) {
      var fileObj = param.file;
      if (fileObj != undefined) {
        // FormData 对象
        var form = new FormData();
        // 文件对象
        form.append("file", fileObj);
        form.append("fileType", "picture");
        form.append("bucketName", "cmny-oss");
        this.$postFormData("dmc/file/uploadFile", form).then(res => {
          if (res.code == 200) {
            this.addForm.headPic = res.result; //添加图片的id
            console.log(this.addForm)
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      }
    },
    //活动轮播图限制
    uploadSuccess(file) {
      const isJPG = file.type == "image/jpeg" || file.type == "image/png";
      const isLt2M = file.size / 1024 / 1024 < 4;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或PNG 格式!");
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 4MB!");
        }
      }
      return isJPG && isLt2M;
    },

    //删除图片
    handleRemove(file, fileList) {
      this.addForm.pic = null;
    },
    formatType(row, column) {
      if (row.type == 0) {
        return '全部'
      } else if (row.type == 1) {
        return '文娱活动'
      } else if (row.type == 2) {
        return '运动健身'
      }else {
        return '其他'
      }
    },
    //点击查询
    onSubmit() {
      if (this.filteForm.dayStr == "") {
        this.getTableData();
      } else {
        this.pageNum = 1;
        this.getTableData();
      }
    },
    closexz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    handleEdit(index, row) {
      console.log(index, row);
      row.type = ""+row.type
      this.dialogFormVisible = true; //打开修改弹窗
      this.addForm = Object.assign({}, row); //深拷贝记录
    },
    //删除
    handleDelete(index, row) {
      if (row.bind == false) {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        }).then(() => {
          let id = row.id;
          console.log(id);
        })
      }
    },
    // 新增弹出框点击确定提交信息
    submitForm(datainfo) {
      let param = this.addForm;
      console.log(param);
      this.addLoading = true;
      let url = "uac/multiRoom/add";
      if (this.addForm.id != null) {
        url = "uac/multiRoom/update";
      }
      this.$postJson(
        url,
        param
      ).then((res) => {
        //旧：dmc/button/add
        console.log(res);
        this.addLoading = false;
        this.dialogFormVisible = false;
        this.$refs.form.resetFields(); //移除校验结果并重置字段值
        if (res.code == "200") {
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "success",
            });
            this.getTableData();
          }, 300);
          console.log("提交成功!");
        } else {
          setTimeout(() => {
            this.$message({
              message: res.message,
              type: "error",
            });
          }, 300);
        }
      });
    },
    //获取分页的紧急按钮数据  只获取pageSize条数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("uac/multiRoom/selectByGroup", param).then(
        (res) => {
          console.log(res);
          //判断是否有数据
          if (res.result.length != 0) {
            this.currentPage = 1;
            this.totalDataNumber = res.result.length * 1;
            this.list = res.result;
            setTimeout(() => {
              this.loading = false;
            }, 200);
          } else {
            this.list = [];
            this.totalDataNumber = 0;
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
        }
      );
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTableData();
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  created() {
    this.getTableData();
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
.buttonlist {
  .buttonlist-m {
    padding: 10px 0 0 5px;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  border: 1px dashed #d9d9d9;
  line-height: 88px;
  text-align: center;
}
.avatar {
  width: 88px;
  height: 88px;
  display: block;
}

.fenye {
  margin: 0;
  padding: 20px 0;
  background: #fff;
}

//新增的dialog
@media screen and (min-width: 1200px) {
 ::v-deep .dangerbuttonxz .el-dialog {
    width: 800px !important;
  }

  .commonwidth {
    width: 260px;
  }

  .bigwidth {
    width: 640px;
  }
}

@media screen and (min-width: 600px) and (max-width: 1199px) {
 ::v-deep .dangerbuttonxz .el-dialog {
    width: 600px !important;
  }

  .commonwidth {
    width: 160px;
  }

  .bigwidth {
    width: 440px;
  }
}
</style>